module.exports = __webpack_public_path__ + "img/exitIcon.83a305e4.svg";